export default {
    chartContainer: {
        position: "relative",
        width: "300px",
    },

    detailsCount: {
        position: "absolute",
        left: "112px",
        top: "50px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "75px"
    },

    count: {
        fontSize: "24px",
        color: "#262626",
        marginBottom: "4px",
        lineHeight: "29px",
    },

    label: {
        fontSize: "16px",
        color: "#676767",
        lineHeight: "19px",
    }
}